'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _limelight = require('@dotdev/limelight');

var _limelight2 = _interopRequireDefault(_limelight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var limelightSelects = function limelightSelects() {
  window.selectWrappers = [];

  var updateSelects = function updateSelects() {
    var startingIndex = selectWrappers.length;
    var selects = document.querySelectorAll('[data-trigger="dropdown"]');

    selects.forEach(function (element, index) {
      var i = startingIndex + index;

      if (!element.classList.contains('limelight-initialised')) {
        element.classList.add('limelight-initialised');
        selectWrappers[i] = new _limelight2.default('' + element.dataset.target, {
          beforeShowCallback: function beforeShowCallback(element, elements) {
            selectWrappers.forEach(function (select, ind) {
              if (_limelight2.default.elements[select.target]) {
                _limelight2.default.elements[select.target].hide();
              }
            });
          },
          hideCallback: function hideCallback(element, elements) {
            var options = element.element.querySelector('.dropdown-options');
            if (options) {
              options.scrollTop = 0;
            }
          }
        });
      }
    });
  };

  document.addEventListener('click', function (event) {
    selectWrappers.forEach(function (select, index) {
      if (_limelight2.default.elements[select.target]) {
        _limelight2.default.elements[select.target].hide();
      }
    });
  });

  document.addEventListener('selects:update', updateSelects);
  updateSelects();
};

exports.default = limelightSelects;